<template>
  <div class="courseArranging">
    <div class="section">
      <el-page-header
        v-if="!show_edit_plan"
        @back="goBack"
        content="正式班排课"
      >
      </el-page-header>
      <el-page-header v-if="show_edit_plan" @back="ShowPlan" content="修改排课">
      </el-page-header>
      <el-row>
        <el-col :span="24">
          <div>
            <el-tooltip
              class="item"
              effect="dark"
              content="可以添加同科目下,其他课程体系的讲次"
              placement="bottom-start"
            >
              <el-button
                style="margin-top: 20px"
                class="arrang_btn"
                type="primary"
                size="mini"
                v-if="editPlan && !editCourseShow && !show_edit_plan"
                @click="InsertPlan"
                >添加讲次<i class="el-icon-question el-icon--right"></i
              ></el-button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="未上课讲次,允许删除."
              placement="bottom-start"
            >
              <el-button
                style="margin-top: 20px"
                class="arrang_btn"
                type="primary"
                size="mini"
                v-if="editPlan && !editCourseShow && !show_edit_plan"
                @click="deleteNormalClassTchPlan"
                >删除讲次<i class="el-icon-question el-icon--right"></i
              ></el-button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="未上课讲次,允许重新排课."
              placement="top-start"
            >
              <el-button
                style="margin-top: 20px"
                class="arrang_btn"
                size="mini"
                v-if="editPlan && !editCourseShow && !show_edit_plan"
                @click="EditNotStartPlan"
                >修改排课<i class="el-icon-question el-icon--right"></i
              ></el-button>
            </el-tooltip>
            <!--
            <el-button
              style="margin-top: 20px; float: right"
              class="arrang_btn"
              plain
              size="mini"
              v-if="editPlan && !editCourseShow && !show_edit_plan"
              @click="ChangePlans"
              >批量修改日期</el-button
            >

            <el-button
              style="margin-top: 20px; float: right"
              class="arrang_btn"
              plain
              size="mini"
              v-if="editPlan && !editCourseShow && !show_edit_plan"
              @click="EditCourseTime"
              >批量修改时段</el-button
            >

            -->
          </div>
        </el-col>
      </el-row>

      <el-row
        :gutter="20"
        style="margin-top: 20px"
        v-if="teaching_plan_list == 0"
      >
        <el-col :span="17">
          <el-card shadow="never">
            <div>
              <span style="font-weight: bold">排课区</span>

              <setTimes @UpdateTimes="UpdateTimes"></setTimes>

              <span
                style="
                  float: right;
                  margin-right: 20px;
                  cursor: pointer;
                  color: #529dfe;
                  font-weight: bold;
                "
                @click="settingCloseDay"
                ><i class="el-icon-edit"></i>停课日</span
              >

              <el-form
                class="form-style"
                label-width="100px"
                v-if="!editPlan || editCourseShow"
                size="mini"
              >
                <el-form-item label="开课日期" required>
                  <el-date-picker
                    v-model="start_date"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    size="mini"
                    placement="bottom-start"
                  ></el-date-picker>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="勾选后,系统排课可自动跳过停课日"
                    placement="top-start"
                  >
                    <el-checkbox
                      v-model="is_stop_day"
                      style="margin-left: 30px; font-size: 14px"
                      >跳过停课日</el-checkbox
                    >
                  </el-tooltip>
                </el-form-item>

                <el-form-item label="上课星期" required>
                  <el-checkbox-group v-model="weekList">
                    <el-checkbox :label="99">每天</el-checkbox>
                    <el-checkbox :label="1" :disabled="!weekDisable"
                      >周一</el-checkbox
                    >
                    <el-checkbox :label="2" :disabled="!weekDisable"
                      >周二</el-checkbox
                    >
                    <el-checkbox :label="3" :disabled="!weekDisable"
                      >周三</el-checkbox
                    >
                    <el-checkbox :label="4" :disabled="!weekDisable"
                      >周四</el-checkbox
                    >
                    <el-checkbox :label="5" :disabled="!weekDisable"
                      >周五</el-checkbox
                    >
                    <el-checkbox :label="6" :disabled="!weekDisable"
                      >周六</el-checkbox
                    >
                    <el-checkbox :label="0" :disabled="!weekDisable"
                      >周日</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>

                <el-form-item v-show="weekDisable" label="上课时段" required>
                  <div
                    class="frame"
                    v-show="weekList.includes(1) && weekDisable"
                  >
                    <span class="title">周一</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[1]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(2) && weekDisable"
                  >
                    <span class="title">周二</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[2]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(3) && weekDisable"
                  >
                    <span class="title">周三</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[3]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(4) && weekDisable"
                  >
                    <span class="title">周四</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[4]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(5) && weekDisable"
                  >
                    <span class="title">周五</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[5]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(6) && weekDisable"
                  >
                    <span class="title">周六</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[6]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(0) && weekDisable"
                  >
                    <span class="title">周日</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[0]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>

                <el-form-item v-show="!weekDisable" label="时段" required>
                  <div class="time-frame" v-if="weekList.length">
                    <div class="frame" v-show="weekList.includes(99)">
                      <p class="title">每天</p>

                      <div class="time">
                        <el-select v-model="selectTime[99]">
                          <el-option
                            v-for="(item, index) in selectTimeList"
                            :key="index"
                            :label="item"
                            :value="item"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="排课间隔" required>
                  <el-radio-group v-model="interval_num">
                    <el-radio :label="0">连续</el-radio>
                    <el-radio :label="1">隔一周</el-radio>
                    <el-radio :label="2">隔两周</el-radio>
                    <el-radio :label="3">隔三周</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>

            <div
              style="text-align: left"
              class="btn"
              v-if="!editPlan || editCourseShow"
            >
              <el-button size="small" type="primary" @click="submit"
                >排 课</el-button
              >
            </div>
          </el-card>
        </el-col>
        <el-col :span="7">
          <el-card shadow="never">
            <div>
              <span style="font-weight: bold"> 选课区</span>
              <span style="margin-left: 10px; color: #606266">{{
                curriculumMaterialList.length
              }}</span>
              <span style="margin-left: 5px">节</span>

              <i
                class="el-icon-refresh-right"
                style="
                  float: right;
                  cursor: pointer;
                  font-size: 16px;
                  font-weight: bold;
                "
                @click="ReChoice"
              ></i>

              <el-table
                ref="multipleTable"
                size="mini"
                :data="curriculumMaterialList"
                tooltip-effect="dark"
                style="width: 100%; margin-top: 20px"
                :header-cell-style="{ background: '#f5f7fa' }"
                height="500px"
                @selection-change="handleSelectionPlan"
              >
                <el-table-column label="序号" width="50">
                  <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column>

                <el-table-column width="80" align="left" label="封面">
                  <template slot-scope="scope">
                    <el-image
                      style="width: 48px; height: 36px"
                      :src="scope.row.img_url"
                      fit="cover"
                    ></el-image>
                  </template>
                </el-table-column>

                <el-table-column label="名称">
                  <template slot-scope="scope">{{ scope.row.title }}</template>
                </el-table-column>

                <el-table-column align="center" width="50" label="操作">
                  <template slot-scope="scope">
                    <i
                      class="el-icon-delete"
                      style="cursor: pointer"
                      @click="DeletePlan(scope.row)"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 20px" v-if="show_edit_plan">
        <el-col :span="17">
          <el-card shadow="never">
            <div>
              <el-form class="form-style" label-width="100px" size="mini">
                <el-form-item label="开课日期" required>
                  <el-date-picker
                    v-model="start_date"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    size="mini"
                    placement="bottom-start"
                  ></el-date-picker>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="勾选后,系统排课可自动跳过停课日"
                    placement="top-start"
                  >
                    <el-checkbox
                      v-model="is_stop_day"
                      style="margin-left: 30px; font-size: 14px"
                      >跳过停课日</el-checkbox
                    >
                  </el-tooltip>

                  <el-button
                    type="text"
                    size="mini"
                    style="margin-left: 5px; font-size: 14px"
                    @click="settingCloseDay"
                    ><i class="el-icon-setting"></i
                  ></el-button>
                </el-form-item>

                <el-form-item label="上课星期" required>
                  <el-checkbox-group v-model="weekList">
                    <el-checkbox :label="99">每天</el-checkbox>
                    <el-checkbox :label="1" :disabled="!weekDisable"
                      >周一</el-checkbox
                    >
                    <el-checkbox :label="2" :disabled="!weekDisable"
                      >周二</el-checkbox
                    >
                    <el-checkbox :label="3" :disabled="!weekDisable"
                      >周三</el-checkbox
                    >
                    <el-checkbox :label="4" :disabled="!weekDisable"
                      >周四</el-checkbox
                    >
                    <el-checkbox :label="5" :disabled="!weekDisable"
                      >周五</el-checkbox
                    >
                    <el-checkbox :label="6" :disabled="!weekDisable"
                      >周六</el-checkbox
                    >
                    <el-checkbox :label="0" :disabled="!weekDisable"
                      >周日</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>

                <el-form-item v-show="weekDisable" label="上课时段" required>
                  <div
                    class="frame"
                    v-show="weekList.includes(1) && weekDisable"
                  >
                    <span class="title">周一</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[1]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(2) && weekDisable"
                  >
                    <span class="title">周二</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[2]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(3) && weekDisable"
                  >
                    <span class="title">周三</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[3]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(4) && weekDisable"
                  >
                    <span class="title">周四</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[4]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(5) && weekDisable"
                  >
                    <span class="title">周五</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[5]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(6) && weekDisable"
                  >
                    <span class="title">周六</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[6]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div
                    class="frame"
                    v-show="weekList.includes(0) && weekDisable"
                  >
                    <span class="title">周日</span>
                    <el-select
                      style="margin-left: 20px"
                      v-model="selectTime[0]"
                    >
                      <el-option
                        v-for="(item, index) in selectTimeList"
                        :key="index"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>

                <el-form-item v-show="!weekDisable" label="时段" required>
                  <div class="time-frame" v-if="weekList.length">
                    <div class="frame" v-show="weekList.includes(99)">
                      <p class="title">每天</p>

                      <div class="time">
                        <el-select v-model="selectTime[99]">
                          <el-option
                            v-for="(item, index) in selectTimeList"
                            :key="index"
                            :label="item"
                            :value="item"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="排课周期" required>
                  <el-radio-group v-model="interval_num">
                    <el-radio :label="0">连续</el-radio>
                    <el-radio :label="1">隔一周</el-radio>
                    <el-radio :label="2">隔两周</el-radio>
                    <el-radio :label="3">隔三周</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>

            <div style="text-align: left" class="btn">
              <el-button
                size="small"
                type="primary"
                @click="bulkUpdateTeachingPlan"
                >修改排课</el-button
              >
            </div>
          </el-card>
        </el-col>
        <el-col :span="7">
          <el-card shadow="never">
            <div>
              已选讲次
              <span>{{ NotStartedCourse.length }}节</span>

              <i
                class="el-icon-refresh-right"
                style="
                  float: right;
                  cursor: pointer;
                  font-size: 16px;
                  font-weight: bold;
                "
                @click="EditNotStartPlan"
              ></i>

              <el-table
                ref="multipleTable"
                size="mini"
                :data="NotStartedCourse"
                tooltip-effect="dark"
                style="width: 100%; margin-top: 20px"
                :header-cell-style="{ background: '#f5f7fa' }"
                height="500px"
                @selection-change="handleSelectionPlan"
              >
                <el-table-column label="讲次名称">
                  <template slot-scope="scope">{{ scope.row.title }}</template>
                </el-table-column>

                <el-table-column align="center" width="50" label="操作">
                  <template slot-scope="scope">
                    <i
                      class="el-icon-delete"
                      style="cursor: pointer"
                      @click="DeleteNotStartedPlan(scope.row)"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-dialog
        class="dialog"
        title="设置停课日"
        :visible.sync="dialogVisible"
        width="560px"
        top="10vh"
      >
        <el-button
          type="text"
          style="margin-left: 20px"
          icon="el-icon-circle-plus"
          @click="addStopDay"
          v-if="!educational_institution_closing_day_list.length"
          >设置停课日</el-button
        >

        <div
          v-for="(item, index) of educational_institution_closing_day_list"
          :key="index"
          style="display: flex; margin: 10px"
        >
          <el-date-picker
            v-model="item.closing_date"
            type="date"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 200px"
          ></el-date-picker>
          <el-input
            v-model="item.name"
            placeholder="请输入名称"
            style="width: 200px; margin-left: 20px"
            placement="bottom-start"
          ></el-input>

          <el-button
            type="text"
            style="margin-left: 20px"
            icon="el-icon-remove"
            @click="reduceStopDay(index)"
          ></el-button>
          <el-button
            type="text"
            style="margin-left: 20px"
            icon="el-icon-circle-plus"
            @click="addStopDay"
            v-if="index === educational_institution_closing_day_list.length - 1"
          ></el-button>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            style="margin-left: 20px"
            @click="dialogVisible = false"
            >取消</el-button
          >
          <el-button size="small" type="primary" @click="saveStopDay"
            >保存</el-button
          >
        </span>
      </el-dialog>

      <div
        class="table-style"
        v-if="editPlan && !editCourseShow && !show_edit_plan"
      >
        <el-table
          size="mini"
          :data="teaching_plan_list"
          :header-cell-style="{ background: '#f5f7fa' }"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column align="left" width="50" label="序号" fixed>
            <template slot-scope="scope"> {{ scope.$index + 1 }} </template>
          </el-table-column>

          <el-table-column width="80" align="left" label="封面">
            <template slot-scope="scope">
              <el-image
                style="width: 48px; height: 36px"
                :src="scope.row.lessionInfo.img_url"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column align="left" label="讲次名称" width="200">
            <template slot-scope="scope">
              <span
                v-if="scope.row.lessionInfo"
                style="color: #409eff; cursor: pointer; font-weight: bold"
                type="primary"
                @click="UpdatePlanInfo(scope.row)"
                >{{ scope.row.lessionInfo.title }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" prop="class_date" label="上课日期">
            <template slot-scope="scope">
              <span>{{ scope.row.start_class_date.split(' ')[0] }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="上课时段">
            <template slot-scope="scope">
              <span>
                {{ scope.row.start_class_date.split(' ')[1] }}~{{
                  scope.row.end_class_date.split(' ')[1]
                }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" prop="lecturer_name" label="上课老师">
          </el-table-column>

          <el-table-column align="left" label="已有学员">
            <template slot-scope="scope">
              <span>
                <el-link type="primary" @click="AuditonStu(scope.row)">{{
                  scope.row.stuTchPlanArr.length
                }}</el-link>
              </span>
            </template>
          </el-table-column>

          <!--
          <el-table-column align="center" label="类型">
            <template slot-scope="scope">
              <span v-if="!scope.row.supplement_original_tch_plan_id">
                常规
              </span>
              <span v-else>补课</span>
            </template>
          </el-table-column>
-->
          <el-table-column align="center" label="讲次状态">
            <template slot-scope="scope">
              <span style="color: green" v-if="scope.row.sign_state == '1'"
                >已上课</span
              >
              <span v-else-if="scope.row.sign_state == '2'">未上课</span>
            </template>
          </el-table-column>
        </el-table>

        <el-row class="classdate">
          <el-col :span="6">
            <div>
              <span class="classdate_start">开课日期:</span>
              {{ info.start_date }}
            </div>
          </el-col>
          <el-col :span="18">
            <div>
              <span class="classdate_stop">结课日期:</span>
              {{ info.end_date }}
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="添加代课老师"
      :visible.sync="teacherDialog"
      width="50%"
      top="20vh"
    >
      <el-form size="mini" :inline="true" class="form-style">
        <el-form-item>
          <el-input placeholder="请输入关键词过滤"> </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table
        size="mini"
        :data="userList"
        border
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column prop="name" label="姓名" fixed></el-table-column>
        <el-table-column prop="name" label="科目"> </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleAddTeacher(scope.row)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="调课" :visible.sync="timeDialog" width="50%" top="20vh">
      <div>
        <el-form class="form-style" size="mini">
          <el-form-item label="上课日期" required>
            <el-date-picker
              v-model="openDate"
              type="date"
              placeholder="选择开课日期"
              value-format="yyyy-MM-dd"
              size="mini"
              placement="bottom-start"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="上课时间" required>
            <el-select v-model="updateSelectTime">
              <el-option
                v-for="(item, index) in selectTimeList"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="timeDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleUpdatePlanTime"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!--修改讲次信息-->
    <el-dialog
      width="660px"
      top="10vh"
      title="讲次信息"
      :visible.sync="dialogFormVisible7"
    >
      <el-form
        size="mini"
        :model="updateform"
        ref="form"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="讲次名称" required>
          <el-input
            style="width: 500px"
            disabled
            v-model="updateform.title"
            placeholder="请输入讲次"
          ></el-input>
        </el-form-item>

        <el-form-item label="上课老师" required>
          <el-select
            style="width: 500px"
            v-model="updateform.lecturer_id"
            :disabled="updateform.start_date"
          >
            <el-option
              :label="item.realName + ' ' + '(' + item.name + ')'"
              :value="item.id"
              v-for="(item, index) of teacherList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上课日期" required>
          <el-date-picker
            type="date"
            placeholder="请选择课程开始时间"
            v-model="updateform.class_date"
            style="width: 500px"
            value-format="yyyy-MM-dd"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上课时段" required>
          <el-time-picker
            v-model="updateform.start_time"
            placeholder="选择开始时间"
            value-format="HH:mm:ss"
          >
          </el-time-picker>
          至
          <el-time-picker
            v-model="updateform.end_time"
            placeholder="选择结束时间"
            value-format="HH:mm:ss"
          >
          </el-time-picker>

          <!--
          <el-time-picker
            style="width: 400px"
            is-range
            v-model="updateform.value"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            value-format="HH:mm:ss"
          >
          </el-time-picker>

-->
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible7 = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="updateTeachingPlan"
          >修 改</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="批量调课" :visible.sync="dialogVisible1" width="500px">
      <el-form
        v-if="dialogVisible1"
        size="mini"
        ref="form_teachplan"
        :model="form_teachplan"
        label-width="100px"
      >
        <el-form-item label="起始讲次">
          <el-select
            size="mini"
            style="width: 300px"
            v-model="form_teachplan.teaching_plan_id"
            placeholder="请选择起始讲次"
          >
            <el-option
              v-for="item of teaching_plan_list"
              :key="item.id"
              :label="item.lessionInfo.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顺延周期">
          <el-input-number
            v-model="form_teachplan.add_num"
            label="顺延周期"
          ></el-input-number>
          <span style="margin-left: 10px">周</span>
        </el-form-item>

        <el-form-item label="注意事项">
          <span>批量调课的讲次，授课时段以班级初始的授课时段为准。</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible1 = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="bulkUpdateTeachingPlan"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="添加讲次" :visible.sync="dialogVisible2" width="500px">
      <el-form
        size="mini"
        ref="form_teachplan"
        :model="form_insert"
        label-width="100px"
      >
        <el-form-item label="选择讲次">
          <insertTeachplan
            v-if="!choosePlanInfo.title"
            ref="insertTeachplan"
            :subject_id="form_insert.subject_id"
            :campus_id="form_insert.campus_id"
            @choosePlan="choosePlan"
          ></insertTeachplan>

          <div v-else>
            <span style="color: #e6a23c">{{ choosePlanInfo.title }}</span>
            <i
              style="cursor: pointer; margin-left: 10px"
              class="el-icon-delete"
              @click="ClearPlanInfo"
            ></i>
          </div>
        </el-form-item>

        <el-form-item label="上课日期" required>
          <el-date-picker
            v-model="form_insert.tchplan_class_date"
            type="date"
            placeholder="选择开课日期"
            value-format="yyyy-MM-dd"
            size="mini"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上课时段" required>
          <el-time-picker
            is-range
            v-model="form_insert.value"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            value-format="HH:mm:ss"
          >
          </el-time-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible2 = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="InsertCourse"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="批量修改时段"
      :visible.sync="dialogVisible3"
      width="500px"
    >
      <el-form
        size="mini"
        ref="form_teachplan"
        :model="form_time"
        label-width="100px"
      >
        <el-form-item label="上课时段" required>
          <el-time-picker
            is-range
            v-model="form_time.value"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            value-format="HH:mm:ss"
          >
          </el-time-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible3 = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="bulkUpdateTeachingPlanPeriod"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog width="80%" title="讲次学员" :visible.sync="dialogFormVisible2">
      <div>
        <el-table
          ref="multipleTable"
          size="small"
          :data="SignStudents"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          >
          <el-table-column align="left" label="姓名" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.stu_tch_plan_type == '1'">{{
                scope.row.studentInfo.studentUserInfo.realname
              }}</span>
              <span v-else-if="scope.row.stu_tch_plan_type == '2'"
                >{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(试听)</span></span
              >
              <span v-else-if="scope.row.stu_tch_plan_type == '3'"
                >{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(调课)</span></span
              >
              <span v-else-if="scope.row.stu_tch_plan_type == '4'"
                >{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(补课)</span></span
              >
              <span v-else-if="scope.row.stu_tch_plan_type == '5'"
                >{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(临加)</span></span
              >
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            prop="studentInfo.name"
            label="平台账号"
            width="150"
          ></el-table-column>

          <el-table-column align="left" label="出勤状态" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.sign_state == 1">出勤</span>
              <span v-else-if="scope.row.sign_state == 2">缺勤</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="计费状态" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.cost_state == 1">计费</span>
              <span v-else-if="scope.row.cost_state == 2">不计费</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="缺勤原因" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.not_come_reason == 1">事假</span>
              <span v-else-if="scope.row.not_come_reason == 2">病假</span>
              <span v-else-if="scope.row.not_come_reason == 3">旷课</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="left"
            label="签到时间"
            prop="sign_date"
          >
          </el-table-column>

          <el-table-column
            align="center"
            label="操作"
            width="150"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="deleteStuOfTeachingPlan(scope.row.student_user_id)"
                >移除学员</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBaseInfo,
  addStopDay,
  addTeachingPlan,
  getPlan,
  getCurriculumPermissionList,
  updatePlanTeacher,
  updatePlanTime,
  getClasses,
  // getCampusTeacherList,
  updateTeachingPlan,
  deleteNormalClassTchPlan,
  bulkUpdateTeachingPlan,
  addSingleNormalClassTchPlan,
  bulkUpdateTeachingPlanPeriod,
  getPrepareCurrculumMaterialList,
  deleteStuOfTeachingPlan,
  updateTchPlanSignState,
} from '@/api/educational'
import { api_eduCampusSelectTchListByCampus } from '@/api/javaApi'

import insertTeachplan from '@/components/insertTeachplan'

import setTimes from '@/components/settimes'

export default {
  name: 'courseArranging',
  components: {
    insertTeachplan: insertTeachplan,
    setTimes: setTimes,
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      selectTime: {
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: '',
        0: '',
        99: '',
      },
      selectTimeList: [],
      weekList: [],
      educational_institution_closing_day_list: [],

      is_encryption: false,
      classtime: null,

      info: {},
      start_date: '',
      is_stop_day: false,
      interval_num: 0, //排课间隔周期
      if_ignore_conflict: 0, //默认检测冲突
      time_quantum: [],
      closing_day: [],
      teaching_plan_list: [{}],
      weekDisable: true,
      teacherDialog: false,
      userList: [],
      teacherList: [],
      teaching_plan_id: '',
      timeDialog: false,
      openDate: '',
      updateSelectTime: '',
      editCourseShow: false,

      dialogFormVisible7: false, //修改讲次
      updateform: {
        title: '',
        lecturer_id: '',
        educational_institution_campus_id: '',
        class_date: '',
        value: [],
        teaching_plan_id: '',
        start_time: '',
        end_time: '',
      },
      form_teachplan: {
        teaching_plan_id: '', //讲次id
        add_num: 1, //顺延周数
        if_ignore_conflict: true, //默认检测冲突
      },

      form_insert: {
        teaching_plan_id: '', //讲次id
        tchplan_class_date: '', //上课日期
        tchplan_start_class_date: '', //开始时段
        tchplan_end_class_date: '', //结束时段
        value: null,
        if_ignore_conflict: 0, //默认检测冲突
        subject_id: '',
        campus_id: '',
      },

      form_time: {
        start_class_date: '', //开始时段
        end_class_date: '', //结束时段
        value: null,
      },

      choosePlanInfo: {
        title: '',
      }, // 调入讲次信息

      tchPlanIds: [], //删除的讲次id组
      tchPlanInfos: [], //选择的讲次

      curriculumMaterialList: [], //讲次列表
      SelectionPlan: [], //已选排课
      NotStartedCourse: [], //未上课讲次

      show_edit_plan: false, //显示重新排课页面

      //查看讲次学员
      dialogFormVisible2: false,

      SignStudents: [],
      current_teachplan_id: '',
    }
  },
  computed: {
    editPlan: function() {
      return !!this.teaching_plan_list.length
    },
  },
  watch: {
    weekList: {
      handler(newValue) {
        if (newValue.includes(99)) {
          this.weekDisable = false
        } else {
          this.weekDisable = true
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getClasses()
    this.getBaseInfo()
    this.getPlan()
    this.getPrepareCurrculumMaterialList()
  },
  methods: {
    ShowPlan() {
      this.show_edit_plan = false
    },
    //更新讲次信息
    UpdatePlanInfo(row) {
      console.log('更新讲次信息11')
      console.log(row)

      this.if_ignore_conflict = 0

      this.dialogFormVisible7 = true

      this.updateform.title = row.lessionInfo.title
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.lecturer_id = row.lecturer_id
      this.updateform.class_date = row.class_date
      this.updateform.classId = this.$route.query.id
      this.updateform.teaching_plan_id = row.id

      var time0 = row.start_class_date.split(' ')[1]
      var time1 = row.end_class_date.split(' ')[1]

      this.updateform.start_time = time0
      this.updateform.end_time = time1

      this.getCampusTeacherList()
    },

    updateTeachingPlan() {
      console.log('更新讲次参数')
      console.log(this.updateform)

      if (!this.updateform.start_time) {
        this.$message.warning('请选择开始时间')
        return
      }

      if (!this.updateform.end_time) {
        this.$message.warning('请选择结束时间')
        return
      }

      updateTeachingPlan({
        lecturer_id: this.updateform.lecturer_id,
        teaching_plan_id: this.updateform.teaching_plan_id,
        class_date: this.updateform.class_date,
        start_class_date: this.updateform.start_time,
        end_class_date: this.updateform.end_time,
        title: this.updateform.title,
        classId: this.updateform.classId,
        if_ignore_conflict: this.if_ignore_conflict,
      }).then((res) => {
        console.log('更新课程讲次')
        console.log(res)
        if (res.is_update) {
          this.$message.success('修改成功')
          this.dialogFormVisible7 = false
          this.getPlan()
        } else {
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '忽略冲突',
            cancelButtonText: '取消排课',
            type: 'warning',
          })
            .then(() => {
              this.if_ignore_conflict = '1'
              this.updateTeachingPlan()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消排课',
              })
              this.dialogFormVisible7 = false
            })
        }
      })
    },

    // 具有科目权限及课程体系的老师
    getCampusTeacherList() {
      api_eduCampusSelectTchListByCampus({
        eduCampusIdList: [this.updateform.educational_institution_campus_id],
      }).then((res) => {
        console.log('具有科目权限及课程体系的老师')
        console.log(res)
        this.teacherList = res //主讲老师
      })
    },

    editCourse() {
      this.editCourseShow = true
    },

    ChangePlans() {
      console.log('准备调课')
      this.dialogVisible1 = true
    },

    EditCourseTime() {
      console.log('批量修改上课时段')
      this.dialogVisible3 = true
    },

    InsertPlan() {
      console.log('插入排课')
      this.dialogVisible2 = true
      this.choosePlanInfo = {}
      this.form_insert.tchplan_class_date = ''
      this.form_insert.if_ignore_conflict = 0 //默认检测冲突
      this.form_insert.value = null
    },

    addSingleNormalClassTchPlan() {
      if (!this.choosePlanInfo.title) {
        this.$message.warning('请选择讲次')
        return
      }

      if (!this.form_insert.tchplan_class_date) {
        this.$message.warning('请选择上课日期')
        return
      }

      if (this.form_insert.value) {
        if (this.form_insert.value[0] == this.form_insert.value[1]) {
          this.$message.warning('开始时间不能等于结束时间')
          return
        }
      } else {
        this.$message.warning('请选择授课时段')
        return
      }

      addSingleNormalClassTchPlan({
        classId: this.$route.query.id,
        lessionId: this.choosePlanInfo.id,
        tchplan_class_date: this.form_insert.tchplan_class_date,
        tchplan_start_class_date: this.form_insert.value[0],
        tchplan_end_class_date: this.form_insert.value[1],
        if_ignore_conflict: this.form_insert.if_ignore_conflict,
      }).then((res) => {
        console.log('插入讲次')
        console.log(res)
        if (res.is_create) {
          this.$message.success('插入成功')
          this.getPlan()
          this.dialogVisible2 = false
        } else {
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '忽略冲突',
            cancelButtonText: '取消排课',
            type: 'warning',
          })
            .then(() => {
              this.form_insert.if_ignore_conflict = '1'
              this.addSingleNormalClassTchPlan()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消排课',
              })
              this.dialogVisible2 = false
            })
        }
      })
    },

    //返回所选的课程
    choosePlan(val) {
      console.log('子组件传值-已选讲次')
      console.log(val)
      this.choosePlanInfo = val
    },

    ClearPlanInfo() {
      this.choosePlanInfo = ''
    },

    InsertCourse() {
      console.log('插入讲次')
      console.log(this.form_insert)
      this.addSingleNormalClassTchPlan()
    },

    bulkUpdateTeachingPlan() {
      console.log('批量修改排课')

      if (!this.start_date) {
        this.$message.warning('请选择开课日期')
        return
      }
      this.time_quantum = []
      if (this.weekList.includes(99)) {
        this.weekList = [99]
      }
      for (let key of this.weekList) {
        this.time_quantum.push({
          type: key,
          start_date: this.selectTime[key].split('~')[0],
          end_date: this.selectTime[key].split('~')[1],
        })
      }
      if (!this.time_quantum.length) {
        this.$message.warning('请选择上课时段')
        return
      }
      for (let key of this.time_quantum) {
        if (!key.start_date) {
          this.$message.warning('请选择时间')
          return
        }
      }

      var tchPlanIdArr = []
      for (let k = 0; k < this.NotStartedCourse.length; k++) {
        tchPlanIdArr.push(this.NotStartedCourse[k].id)
      }

      console.log('提交参数')
      console.log(this.$route.query.id)
      console.log(this.start_date)
      console.log(this.is_stop_day)
      console.log(this.interval_num)
      console.log(JSON.stringify(this.time_quantum))
      console.log(JSON.stringify(this.closing_day))
      console.log(this.form_teachplan.if_ignore_conflict)
      console.log(tchPlanIdArr)

      bulkUpdateTeachingPlan({
        classes_id: this.$route.query.id,
        start_date: this.start_date,
        is_stop_day: this.is_stop_day,
        interval_num: this.interval_num,
        time_quantum: JSON.stringify(this.time_quantum),
        closing_day: JSON.stringify(this.closing_day),
        if_ignore_conflict: this.form_teachplan.if_ignore_conflict ? '0' : '1',
        tchPlanIdArr: JSON.stringify(tchPlanIdArr),
      }).then((res) => {
        console.log('批量修改排课')
        console.log(res)

        if (res.is_create) {
          this.$message.success('修改成功')
          this.dialogVisible1 = false
          this.show_edit_plan = false
          this.getPlan()
        } else {
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '忽略冲突',
            cancelButtonText: '取消排课',
            type: 'warning',
          })
            .then(() => {
              this.form_teachplan.if_ignore_conflict = false
              this.bulkUpdateTeachingPlan()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消调课',
              })
            })
        }
      })
    },

    //批量修改上课时间
    bulkUpdateTeachingPlanPeriod() {
      console.log('授课时段')
      console.log(this.form_time)

      if (!this.form_time.value) {
        this.$message.warning('请设置上课时段')
        return
      }

      if (this.tchPlanIds.length == 0) {
        this.$message.warning('请选择需要调整的讲次')
        return
      }

      bulkUpdateTeachingPlanPeriod({
        tchPlanIdArr: JSON.stringify(this.tchPlanIds),
        start_time: this.form_time.value[0],
        end_time: this.form_time.value[1],
      }).then((res) => {
        console.log('批量修改上课日期')
        console.log(res)
        if (res.is_update) {
          this.$message.success('修改成功')
          this.dialogVisible3 = false
          this.getPlan()
        }
      })
    },

    handleSelectionChange(val) {
      console.log('删除讲次')
      console.log(val)
      this.tchPlanInfos = val
      this.tchPlanIds = []
      for (let k = 0; k < val.length; k++) {
        this.tchPlanIds.push(val[k].id)
      }

      console.log('即将删除的讲次id组')
      console.log(this.tchPlanIds)
    },

    handleSelectionPlan(val) {
      console.log('已选讲次')
      console.log(val)
      this.SelectionPlan = val
    },

    deleteNormalClassTchPlan() {
      this.$confirm('确定删除排课计划吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log('删除排课')

          if (this.tchPlanIds.length == 0) {
            this.$message.warning('请选择需要删除的讲次')
            return
          }

          deleteNormalClassTchPlan({
            classId: this.$route.query.id,
            tchPlanIds: JSON.stringify(this.tchPlanIds),
          }).then((res) => {
            console.log('删除排课')
            console.log(res)
            if (res.is_delete) {
              if (res.failTchPlanArr.length > 0) {
                for (let k = 0; k < res.failTchPlanArr.length; k++) {
                  setTimeout(() => {
                    this.$notify({
                      title: '警告',
                      message:
                        this.tchPlanInfos[k].lessionInfo.title +
                        ',' +
                        res.failTchPlanArr[k].msg,
                      type: 'warning',
                    })
                  }, 100)
                }
              } else {
                this.$message.success('删除成功')
              }

              this.getPlan()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    cloneEditCourse() {
      this.start_date = ''
      this.weekList = []
      this.is_stop_day = false
      this.editCourseShow = false
    },
    handleUpdatePlanTime() {
      if (!this.openDate) {
        this.$message.warning('请选择上课日期')
        return
      } else if (!this.updateSelectTime) {
        this.$message.warning('请选择上课时间段')
        return
      }
      updatePlanTime({
        teaching_plan_id: this.teaching_plan_id,
        class_date: this.openDate,
        start_class_date: this.updateSelectTime.split('~')[0],
        end_class_date: this.updateSelectTime.split('~')[1],
      }).then(() => {
        this.$message.success('调整时间成功')
        this.getPlan()
        this.timeDialog = false
      })
    },
    updatePlanTime(row) {
      this.teaching_plan_id = row.id
      this.openDate = row.start_class_date.split(' ')[0]
      this.updateSelectTime = `${row.start_class_date.split(' ')[1]}~${
        row.end_class_date.split(' ')[1]
      }`
      this.timeDialog = true
    },
    handleAddTeacher(row) {
      updatePlanTeacher({
        lecturer_id: row.id,
        teaching_plan_id: this.teaching_plan_id,
      }).then(() => {
        this.$message.success('添加教师成功')
        this.getPlan()
        this.teacherDialog = false
      })
    },
    // 获取老师
    getCurriculumPermissionList() {
      getCurriculumPermissionList({
        curriculum_id: this.info.curriculum_id,
      }).then((res) => {
        this.userList = res.user_list
      })
    },
    getPlan() {
      getPlan({
        classes_id: this.$route.query.id,
      }).then((res) => {
        this.teaching_plan_list = res.teaching_plan_list
        console.log('this.teaching_plan_list')
        console.log(this.teaching_plan_list)
      })
    },
    submit() {
      if (!this.start_date) {
        this.$message.warning('请选择开课日期')
        return
      }
      this.time_quantum = []
      if (this.weekList.includes(99)) {
        this.weekList = [99]
      }
      for (let key of this.weekList) {
        this.time_quantum.push({
          type: key,
          start_date: this.selectTime[key].split('~')[0],
          end_date: this.selectTime[key].split('~')[1],
        })
      }
      if (!this.time_quantum.length) {
        this.$message.warning('请选择上课时段')
        return
      }
      for (let key of this.time_quantum) {
        if (!key.start_date) {
          this.$message.warning('请选择时间')
          return
        }
      }

      if (this.curriculumMaterialList.length == 0) {
        this.$message.warning('请选择讲次')
        return
      }

      var ids = []

      for (let k = 0; k < this.curriculumMaterialList.length; k++) {
        ids.push(this.curriculumMaterialList[k].id)
      }

      addTeachingPlan({
        classes_id: this.$route.query.id,
        start_date: this.start_date,
        is_stop_day: this.is_stop_day,
        interval_num: this.interval_num,
        time_quantum: JSON.stringify(this.time_quantum),
        closing_day: JSON.stringify(this.closing_day),
        if_ignore_conflict: this.if_ignore_conflict,
        curriculumMaterialIdArr: JSON.stringify(ids),
      }).then((res) => {
        console.log('排课信息返回')
        console.log(res)

        if (res.is_create) {
          this.$message.success('排课成功')
          if (this.$route.query.id) {
            this.cloneEditCourse()
          }
          this.getPlan()
          this.getClasses()
        } else {
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '忽略冲突',
            cancelButtonText: '取消排课',
            type: 'warning',
          })
            .then(() => {
              this.if_ignore_conflict = 1
              this.submit()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消排课',
              })
            })
        }
      })
    },
    settingCloseDay() {
      this.getBaseInfo()
      this.dialogVisible = true
    },

    settingTimes() {
      this.getBaseInfo()

      this.dialogVisible4 = true
    },

    saveStopDay() {
      for (
        let i = 0;
        i < this.educational_institution_closing_day_list.length;
        i++
      ) {
        if (
          !this.educational_institution_closing_day_list[i].closing_date ||
          !this.educational_institution_closing_day_list[i].name
        ) {
          this.$message.warning('请填写日期或名称')
          return
        }
      }
      let closing_day_list = this.educational_institution_closing_day_list.map(
        (item) => {
          return {
            date: item.closing_date,
            name: item.name,
          }
        }
      )
      addStopDay({
        closing_day_list: JSON.stringify(closing_day_list),
      }).then(() => {
        this.$message.success('保存成功')
        this.dialogVisible = false
      })
    },
    addStopDay() {
      this.educational_institution_closing_day_list.push({
        closing_date: '',
        name: '',
      })
    },
    reduceStopDay(index) {
      this.educational_institution_closing_day_list.splice(index, 1)
    },
    getBaseInfo() {
      this.selectTime[1] = ''
      this.selectTime[2] = ''
      this.selectTime[3] = ''
      this.selectTime[4] = ''
      this.selectTime[5] = ''
      this.selectTime[6] = ''
      this.selectTime[0] = ''
      this.selectTime[99] = ''

      getBaseInfo().then((res) => {
        console.log('获得校区基础排课信息')
        console.log(res)

        this.is_encryption = res.educational_institution_obj[0].is_encryption

        this.closing_day = []
        this.educational_institution_closing_day_list =
          res.educational_institution_closing_day_list

        for (let key of res.educational_institution_closing_day_list) {
          this.closing_day.push(key.closing_date)
        }

        this.selectTimeList = []

        for (let key of res.educational_institution_class_day_list) {
          this.selectTimeList.push(
            `${key.start_class_date.slice(0, 5)}~${key.end_class_date.slice(
              0,
              5
            )}`
          )
        }

        this.$forceUpdate()
      })
    },
    getClasses() {
      console.log('班级ID')
      console.log(this.$route.query.id)

      getClasses({
        class_id: this.$route.query.id,
      }).then((res) => {
        this.info = res.class_obj
        console.log('班级信息')
        console.log(this.info)

        this.form_insert.subject_id = res.class_obj.subject_id
        this.form_insert.campus_id =
          res.class_obj.educational_institution_campus_id
      })
    },

    goBack() {
      this.cloneEditCourse()
      this.$router.push({
        name: 'class-management',
      })
    },

    //获得讲次
    getPrepareCurrculumMaterialList() {
      getPrepareCurrculumMaterialList({
        curriculum_id: this.$route.query.curriculum_id,
      }).then((res) => {
        console.log('讲次列表')
        console.log(res)
        this.curriculumMaterialList = res.curriculumMaterialList
        //this.dialogVisible = true;
        //this.curriculum_title = title;
      })
    },

    DeletePlan(row) {
      console.log(row)
      for (let k = 0; k < this.curriculumMaterialList.length; k++) {
        if (this.curriculumMaterialList[k].id == row.id) {
          this.curriculumMaterialList.splice(k, 1)
        }
      }
    },

    DeleteNotStartedPlan(row) {
      for (let k = 0; k < this.NotStartedCourse.length; k++) {
        if (this.NotStartedCourse[k].id == row.id) {
          this.NotStartedCourse.splice(k, 1)
        }
      }
    },

    ReChoice() {
      this.$confirm('确定恢复默认讲次?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.getPrepareCurrculumMaterialList()
      })
    },

    EditNotStartPlan() {
      console.log('未上课讲次,重新排课')
      console.log(this.teaching_plan_list)

      this.show_edit_plan = true
      this.NotStartedCourse = []

      for (let k = 0; k < this.teaching_plan_list.length; k++) {
        if (this.teaching_plan_list[k].sign_state == '2') {
          var plan = {
            id: this.teaching_plan_list[k].id,
            title: this.teaching_plan_list[k].lessionInfo.title,
          }

          this.NotStartedCourse.push(plan)
        }
      }
      console.log('所有未签到讲次')
      console.log(this.NotStartedCourse)
    },

    BackPlan() {
      this.show_edit_plan = false
    },

    //更新了上课时段
    UpdateTimes() {
      console.log('上课时段更新')
      this.getBaseInfo()
    },

    //管理讲次学员
    AuditonStu(row) {
      console.log('管理试听学员')
      console.log(row)
      this.dialogFormVisible2 = true
      this.SignStudents = row.stuTchPlanArr
      this.current_teachplan_id = row.id
    },

    //从教学计划中移除学员
    deleteStuOfTeachingPlan(id) {
      this.$confirm('确定将学员从本节课中移除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteStuOfTeachingPlan({
          teaching_plan_id: this.current_teachplan_id,
          studentId: id,
        }).then((res) => {
          console.log('将学员移除讲次')
          console.log(res)

          if (res.is_delete) {
            for (let k = 0; k < this.SignStudents.length; k++) {
              console.log(id)
              console.log(this.SignStudents[k])

              if (id == this.SignStudents[k].studentInfo.id) {
                console.log('学员ID相同')
                this.SignStudents.splice(k, 1)
              }
            }

            if (this.SignStudents.length == 0) {
              console.log('重置课堂状态')
              updateTchPlanSignState({
                teaching_plan_id: this.current_teachplan_id,
                sign_state: '2',
              }).then((res) => {
                console.log('重置上课状态')
                console.log(res)
                if (res.is_update) {
                  this.getPlan()
                }
              })
            }

            this.$message.success('移除学员成功')
            if (this.SignStudents.length > 0) {
              this.getPlan()
            }
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.courseArranging {
  .section {
    box-sizing: border-box;
    margin: 10px;
    padding: 15px 15px 15px 15px;
    border-radius: 5px;
    background-color: #fff;

    .arrang_btn {
      margin-bottom: 20px;
    }

    .classdate {
      margin-top: 20px;
      .classdate_start {
        font-weight: 500;
      }
      .classdate_stop {
        font-weight: 500;
      }
    }
    .hint {
      margin-left: 30px;
      font-size: 14px;
      color: red;
    }
    .time-frame {
      background-color: #f7f8fa;
      margin: 20px 0 0 20px;
      padding: 20px 0;
      border-radius: 5px;
      .frame {
        display: flex;
        align-items: center;
        border-radius: 5px;
        .title {
          font-size: 14px;
          margin-left: 20px;
        }
        .time {
          margin-left: 20px;
        }
      }
    }
    .btn {
      margin: 20px 0 0 20px;
    }

    .dialog {
      padding-bottom: 20px;
    }
  }
}
</style>
